import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showWaitingAreaDuringCallsModal } from '../../../../actions/modal.js';
import { updateDuringCallDetail } from '../../../../actions/waitingArea.js';

export default function RightPanelTopWaitingAreaDuringCalls(props) {
  const dispatch = useDispatch();
  const [updatingDuringCallsApi, setUpdatingDuringCallsApi] = useState(false);

  const updateDuringCallDetailWithInComponent = () => {
    setUpdatingDuringCallsApi(true);
    let duringCallDetail = {
      callQuality: props.duringCallsForm.callQuality,
      message:
        props.duringCallsForm.message === null || props.duringCallsForm.message === undefined
          ? ''
          : props.duringCallsForm.message,
      displayMessageMinutes:
        props.duringCallsForm.displayMessageMinutes == '' ? 0 : props.duringCallsForm.displayMessageMinutes,
      displayMessageSeconds:
        props.duringCallsForm.displayMessageSeconds == '' ? 0 : props.duringCallsForm.displayMessageSeconds,
      isRecordingEnabled: props.duringCallsForm.isRecordingEnabled,
      showCallerQueuePosition: props.duringCallsForm.showCallerQueuePosition,
      showWaitingAreaBulletin: props.duringCallsForm.showWaitingAreaBulletin,
    };
    let cb = (hideModal) => {
      setUpdatingDuringCallsApi(false);
      dispatch(showWaitingAreaDuringCallsModal(!hideModal));
    };
    dispatch(updateDuringCallDetail(props.waitingArea.id, duringCallDetail, cb));
  };

  const closeModal = () => {
    dispatch(showWaitingAreaDuringCallsModal(false));
  };

  const saveModal = (event) => {
    if (!window.$(event.target).hasClass('disable')) {
      updateDuringCallDetailWithInComponent();
    }
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover max-width color-white mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="mrbl  mrtxxs pdlnull ">
          <button
            type="button"
            onClick={saveModal}
            className={
              updatingDuringCallsApi
                ? saveClasses + ' loading'
                : props.duringCallsForm.message.length > 480
                ? saveClasses + ' disable'
                : saveClasses
            }
          >
            <i className="checkmark icon" />
            {APP.LANGUAGE.Save}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="ui cancel  left-text labeled mrtm icon button color-bad-things color-bad-things-hover color-white max-width mrlnull"
          >
            <i className="remove icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      ) : (
        <div className="mrbl  mrtxxs pdlnull ">
          <button
            type="button"
            onClick={closeModal}
            className="ui cancel  left-text labeled icon button color-bad-things color-bad-things-hover color-white max-width mrlnull"
          >
            <i className="remove icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
}
